import React, {useEffect, useState} from "react";
import {MenuItem, Typography} from "@mui/material";
import axios from "axios";
import {useNavigate} from "react-router-dom";
import CCInputLabel from "../Common/CCInputLabel";
import CCSelect from "../Common/CCSelect";

import {Button, Dialog, DialogActions, DialogContent, Link} from "@mui/material";
import {Link as RouterLink} from "react-router-dom";
import CCPulse from "../Common/CCPulse";
import css_shared from "./css/LoginCommon.module.scss";
import css_self from "./css/LoginMain.module.scss";
import "./css/LoginMain.scss";
import enlilImage from "../../assets/logo-5cd08655.svg";
import {Blue3} from "../../theme/styles";
import useAppContext from "../../util/AppContext";
import {useLocation} from "react-router-dom";

export default function SSOLogin() {

    const navigate = useNavigate();

    const {sessionContext} = useAppContext();

    const [submitting, setSubmitting] = useState(false);

    const [companies, setCompanies] = useState([]);
    const [displayedCompany, setDisplayedCompany] = useState("");
    const [displayedCompanies, setDisplayedCompanies] = useState([]);
    const [displayedVisibility, setDisplayedVisibility] = useState(null);
    const [errorText, setErrorText] = useState(undefined);

    const location = useLocation();

    function default_visibility(companies, company_name) {

        if (Object.keys(companies).length > 0 && company_name in companies) {

            const company = companies[company_name];
            const companyUSID = company["companyUSID"];

            if (company["Positions"].length > 0) {
                const position = company["Positions"];
                return `${companyUSID}:Position:${position["USID"]}`;
            }

            if (company["UserGroups"].length > 0) {
                const userGroup = company["UserGroups"];
                return `${companyUSID}:UserGroup:${userGroup["USID"]}`;
            }

            if (company["WorkGroups"].length > 0) {
                const workgroup = company["WorkGroups"];
                return `${companyUSID}:WorkGroup:${workgroup["USID"]}`;
            }
        }
        return null;
    }

    async function login() {

        setSubmitting(true);

        let startIndex = location.search.indexOf("sid=");
        const response = await axios({
            method: "POST",
            baseURL: process.env.REACT_APP_API_URL,
            url: "t8/v1/authenticate",
            json: true,
            data: {
                sid: location.search.substring(startIndex + 4, startIndex + 40),
                Visibility: displayedVisibility,

            },
        }).catch(e => e.response || e);

        if (response instanceof Error) {
            return response;
        }

        if (response.status !== 200) {
            return response;
        }

        if (response.data.Code === "CC-ADC7-49A2" || response.data.Code === "CC-E5EB-43D5") {

            const companies = response.data["Companies"];

            const displayedCompanies = Object.keys(companies).sort();
            const displayedCompany = displayedCompanies[0];
            const displayedVisibility = default_visibility(companies, displayedCompany);

            setCompanies(companies);

            setDisplayedCompany(displayedCompany);
            setDisplayedCompanies(displayedCompanies);
            setDisplayedVisibility(displayedVisibility);

            setSubmitting(false);
        } else {
            let visibilityMode, visibilityValue
            if (displayedVisibility) {
                [, visibilityMode, visibilityValue] = displayedVisibility.split(":");
            } else {
                visibilityMode = "Position"
                visibilityValue = response.data["Company"]["Positions"][0].USID
            }

            /*
            if (response.data["Company"]["Positions"].length > 0) {
                visibilityMode = "Position";
                visibilityValue = response.data["Company"]["Positions"][0].USID;
            } else if (response.data["Company"]["UserGroups"].length > 0) {
                visibilityMode = "UserGroup";
                visibilityValue = response.data["Company"]["UserGroups"][0].USID;
            } else if (response.data["Company"]["WorkGroups"].length > 0) {
                visibilityMode = "WorkGroup";
                visibilityValue = response.data["Company"]["WorkGroup"][0].USID;
            }
            */

            sessionContext.setIdentityToken(response.data["IdentityToken"])
            sessionContext.setSID(response.data["SID"])
            sessionContext.setSessionUSID(response.data["Session"])
            sessionContext.setAccessToken(response.data["AccessToken"])
            sessionContext.setRefreshToken(response.data["RefreshToken"])
            sessionContext.setActiveVisibility(visibilityMode, visibilityValue)
            sessionContext.setCompanyName(response.data["Company"]["CompanyName"])
            sessionContext.setCompany(response.data["Company"])
            sessionContext.setRoles(response.data["Roles"])
            sessionContext.setPrivileges(response.data["NewPrivileges"])
            sessionContext.setPrivilegeConstraints(response.data["PrivilegeConstraints"])
            sessionContext.setTenants(response.data["Tenants"])
            sessionContext.setShowLoginDialog(false)
            sessionContext.setPickValues(response.data["PickValues"])
            sessionContext.setS3AccessKeyId(response.data["S3AccessKeyId"])
            sessionContext.setS3SecretAccessKey(response.data["S3SecretAccessKey"])
            sessionContext.setS3SessionToken(response.data["S3SessionToken"])

            return false;
       }
    }

    useEffect(() => {
        login().then(() => {
        });

        return () => {
        }
    }, []);

    let loginFormToPresent = null;

    if (displayedCompanies.length >= 1) {

        let menuItems = [];

        for (let i = 0; i < companies[displayedCompany]["Positions"].length; i++) {
            if (i === 0) {
                menuItems.push(<MenuItem disabled value={"positions"} key={i + 1000}>Positions</MenuItem>);
            }
            const companyUSID = companies[displayedCompany]["CompanyUSID"];
            const position = companies[displayedCompany]["Positions"][i];
            menuItems.push(<MenuItem value={`${companyUSID}:Position:${position["USID"]}`} key={i}>&emsp;{position["Name"]}</MenuItem>);
        }

        for (let i = 0; i < companies[displayedCompany]["UserGroups"].length; i++) {
            if (i === 0) {
                menuItems.push(<MenuItem disabled value={"userGroups"} key={i + 1500}>User Groups</MenuItem>);
            }
            const companyUSID = companies[displayedCompany]["CompanyUSID"];
            const userGroup = companies[displayedCompany]["UserGroups"][i];
            menuItems.push(<MenuItem value={`${companyUSID}:UserGroups:${userGroup["USID"]}`} key={i + 50}>&emsp;{userGroup["Name"]}</MenuItem>);
        }

        for (let i = 0; i < companies[displayedCompany]["WorkGroups"].length; i++) {
            if (i === 0) {
                menuItems.push(<MenuItem disabled value={"workgroups"} key={i + 2000}>Workgroups</MenuItem>);
            }
            const companyUSID = companies[displayedCompany]["CompanyUSID"];
            const workgroup = companies[displayedCompany]["WorkGroups"][i];
            menuItems.push(<MenuItem value={`${companyUSID}:WorkGroup:${workgroup["USID"]}`} key={i + 100}>&emsp;{workgroup["Name"]}</MenuItem>);
        }

        loginFormToPresent = (
            <>
                {displayedCompanies.length === 1 ? (
                    <Typography className={css_shared.Title}>Select your persona</Typography>
                ) : (
                    <>
                        <Typography className={css_shared.Title}>Select your company and persona</Typography>
                        <CCInputLabel>Company</CCInputLabel>
                        <CCSelect
                            size={"small"}
                            fullWidth={true}
                            value={displayedCompany}
                            onChange={e => {
                                setDisplayedCompany(e.target.value);
                                setDisplayedVisibility(default_visibility(companies, e.target.value));
                            }}
                        >
                            {displayedCompanies.map(company => (
                                <MenuItem value={company} key={`select-company-${company}`}>{company}</MenuItem>
                            ))}
                        </CCSelect>
                    </>
                )}
                <CCInputLabel>Persona</CCInputLabel>
                <CCSelect
                    size={"small"}
                    fullWidth={true}
                    value={displayedVisibility}
                    onChange={e => setDisplayedVisibility(e.target.value)}
                >
                    {menuItems}
                </CCSelect>
                <Button
                    {...{"data-cc-component": "CCLoginButton"}}
                    {...{"data-animate": submitting}}
                    fullWidth
                    disabled={
                        submitting ||
                        (displayedCompanies.length > 0 && (displayedVisibility === null || displayedVisibility.length === 0))
                    }
                    onClick={() => {
                        setErrorText(undefined);
                        login().then(() => {
                        });
                    }}
                >
                    <span style={submitting ? {visibility: "hidden"} : undefined}>Select</span>
                    {submitting ? <CCPulse className={css_self.Pulse} /> : undefined}
                </Button>
            </>
        );
    }

    return (
        <Dialog maxWidth="md" open={!submitting} scroll="body">
            <DialogContent style={{padding: "0 16px"}}>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "center"}}>
                    <div>
                        <img className={css_self.EnlilLogo} src={enlilImage} alt="Home"/>
                    </div>
                    <div style={{marginTop: "10px"}}>
                        <span style={{marginLeft: "65px", fontSize: 25, fontWeight: 400, color: Blue3}}>| Milestone View</span>
                    </div>
                </div>
                {loginFormToPresent}
                {displayedCompanies.length > 0 ? (
                    <Typography className={css_self.HelpText}>
                        <Link variant="inherit" color="inherit" component={RouterLink} to="#" replace={true} onClick={() => navigate("/logout", {replace: true})}>Start over</Link>
                    </Typography>
                ) : null}
            </DialogContent>
            <DialogActions>
            </DialogActions>
        </Dialog>
    );

}